import { Translation } from '../contexts/language/translationType';

export const getTranslationByPath = (obj: Translation, path: string): string => {
  if (!path) {
    return path
  }

  const keys = path.split('.');
  const translation = keys.reduce<any>((acc, key) => acc && acc[key], obj);

  if(!translation) {
    return path
  }

  return translation
}
